// extracted by mini-css-extract-plugin
module.exports = {"title":"ccfda6eb9f--title--DgtKV","advantages":"ccfda6eb9f--advantages--g71ol","advantage":"ccfda6eb9f--advantage--Xfhz5","sub-title":"ccfda6eb9f--sub-title--E7ab8"};